import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import App from'./App';
import AppUser from './AppUser';

function Routes(){
    return (
        <Router>
            <Switch>
                <Route path="/" exact component={App} />
                <Route path="/:id"  exact component={AppUser} />
            </Switch>
        </Router>
    )
}

export default Routes;  

